/**
 * Resolve the school-shop header banner photos for a menu item.
 *
 * Precedence: the brand's uploaded images from the variations payload
 * (`menuItemImages[menuKey] = {desktop, mobile}`), then the brand's static
 * fallback map (`fallback[menuKey] = {backgroundImage, backgroundImageMobile}`),
 * then `{}` → the design-system default photos inside SecondaryBanner.
 * A missing mobile image falls back to the desktop one.
 */
export default function resolveHeaderImages({ menuItemImages, menuItemKey, fallback } = {}) {
  const uploaded = menuItemKey ? menuItemImages?.[menuItemKey] : null;
  if (uploaded && (uploaded.desktop || uploaded.mobile)) {
    const desktop = uploaded.desktop || uploaded.mobile;
    return { backgroundImage: desktop, backgroundImageMobile: uploaded.mobile || desktop };
  }
  return (menuItemKey && fallback?.[menuItemKey]) || {};
}
